import './index.scss';
import './api/setup-axios';
import '@cloudscape-design/global-styles/index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import { initializeRum } from './config/rum.config';
import { store } from './store/store';

// Initialize CloudWatch RUM for client-side monitoring
initializeRum();

const persistedStore = persistStore(store);
const container = document?.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate persistor={persistedStore}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
